import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InboundArrow from './icon-inbound-arrow.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InboundArrow {...validProps} />;
}
SvgComponent.iconName = 'inboundArrow';

/**
 * @deprecated This is a legacy icon
 */
export const InboundArrowIcon = svgIconWrapper(SvgComponent);
